import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { OccupationFormFields } from "../_components/occupation-form-fields";

export function CreateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:CreateOccupation");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <OccupationFormFields />
    </CenteredLayout>
  );
}
